module.exports = __webpack_public_path__ + "img/login.5107d17.png";